import { render, staticRenderFns } from "./TheCertificatesUpdate.vue?vue&type=template&id=1e1993b4"
import script from "./TheCertificatesUpdate.vue?vue&type=script&lang=js"
export * from "./TheCertificatesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports